import { initializeApp } from 'firebase/app';
import { getDatabase }   from 'firebase/database';
import { getStorage }    from 'firebase/storage';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:       process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const db      = getDatabase(app);
export const storage = getStorage(app);

// Firebase Storage rules require `auth != null` on /screenshots/* (Security
// Phase 2 — see popuppush-iac/storage.rules). The admin SPA previously never
// authenticated, so every getDownloadURL() on a screenshot was permission-
// denied. Sign in anonymously (anonymous auth is enabled on the project, same
// as the player and the dashboard SPA) so reads are authorized.
//
// `authReady` resolves once sign-in settles. Screenshot reads await it before
// calling getDownloadURL, because getDownloadURL is a one-shot request that —
// unlike an RTDB onValue() listener — does NOT re-fire when the auth token
// lands, so it must not run before sign-in completes.
const auth = getAuth(app);
export const authReady = new Promise((resolve) => {
  if (auth.currentUser) { resolve(); return; }
  const trySignIn = (retriesLeft) => {
    signInAnonymously(auth)
      .then(() => resolve())
      .catch((err) => {
        console.warn('[firebase] anonymous sign-in failed', err?.code || err);
        if (retriesLeft > 0) {
          setTimeout(() => {
            if (auth.currentUser) resolve();
            else trySignIn(retriesLeft - 1);
          }, 3000);
        } else {
          resolve(); // stop blocking reads; they'll surface their own error
        }
      });
  };
  trySignIn(1);
});
